import VueI18Next from '@panter/vue-i18next';
import i18next from 'i18next';
import Vue from 'vue';

export const VUETIFY_TRANSLATIONS_NAMESPACE = 'vuetifyTranslations';
const MAIN_TRANSLATIONS_NAMESPACE = 'ifAllPagesTranslations';
const REFERENCE_LANGUAGE = 'sv';
const FALLBACK_LANGUAGE = 'en';

Vue.use(VueI18Next);

const resources = {
  en: {
    [MAIN_TRANSLATIONS_NAMESPACE]: require('../locales/en/all-pages-translations'),
    [VUETIFY_TRANSLATIONS_NAMESPACE]: require('../locales/en/vuetify-translations'),
  },
  sv: {
    [MAIN_TRANSLATIONS_NAMESPACE]: require('../locales/sv/all-pages-translations'),
    [VUETIFY_TRANSLATIONS_NAMESPACE]: require('../locales/sv/vuetify-translations'),
  },
};

const commonConfig = {
  lng: REFERENCE_LANGUAGE,
  fallbackLng: FALLBACK_LANGUAGE,
  ns: [MAIN_TRANSLATIONS_NAMESPACE, VUETIFY_TRANSLATIONS_NAMESPACE],
  defaultNS: MAIN_TRANSLATIONS_NAMESPACE,
  debug: process.env.NODE_ENV !== 'production',
  resources: resources,
};

export const i18n = i18next.createInstance();

export async function initializeVueI18Next() {
  await i18n.init(commonConfig);
  return new VueI18Next(i18n);
}
